import { render, staticRenderFns } from "./invoice-sync-items.vue?vue&type=template&id=08d7c17c&scoped=true&"
import script from "./invoice-sync-items.ts?vue&type=script&lang=ts&"
export * from "./invoice-sync-items.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-sync-items.scss?vue&type=style&index=0&id=08d7c17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7c17c",
  null
  
)

export default component.exports